import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

export { Container };
